import { useAllVoices } from '@/hooks/useAllVoices';
import { IVoice, Providers } from '@d-id/types';
import { useMemo } from 'react';

export const isClonedVoice = (voice: IVoice) => !voice.gender && voice.provider === Providers.Elevenlabs;

export const useClonedVoices = (): IVoice[] => {
    const { data = [] } = useAllVoices();

    const clonedVoiceData: IVoice[] = useMemo(() => {
        return data.filter(v => isClonedVoice(v));
    }, [data]);

    return clonedVoiceData;
};
